import React from 'react';

import { UniformContext } from '@uniformdev/context-react';

import ContentNotFoundErrorBoundary from '@/content/utils/content-not-found-error-boundary';
import { FourOhFourPageTemplate } from '@/templates/404/404-page/src/404-page.template';
import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { UniformEntryPageProps } from '../../../../pages/uniform-entry/uniform-entry-page';
import { UniformWrapper } from '../../../../uniform/uniform-wrapper';
import { useWAEContext } from '../../../../uniform/utils/wae-context-provider';

export const UniformEntryPageTemplate: React.FC<UniformEntryPageProps> = ({
	composition,
	isUniformPlayground,
	isAllowPostMessage,
}) => {
	const { uniformContext } = useWAEContext();
	// The default "server-only" transfer-state script exists only in the SSR tree, so
	// hydration finds an extra node and client-renders the whole page
	const includeTransferState = checkFeatureFlagGate(featureFlags.personalizationNoContentSwap)
		? 'always'
		: 'server-only';

	return (
		<ContentNotFoundErrorBoundary fallback={<FourOhFourPageTemplate />}>
			<UniformContext context={uniformContext} includeTransferState={includeTransferState}>
				<UniformWrapper
					composition={composition}
					isUniformPlayground={isUniformPlayground}
					isAllowPostMessage={isAllowPostMessage}
				/>
			</UniformContext>
		</ContentNotFoundErrorBoundary>
	);
};
